import { ofType } from 'redux-observable';
import { switchMap, map, catchError } from 'rxjs/operators';
import { from, of } from 'rxjs';
import { ADD_STAFF_MEMBER_NAMES_REQUEST, EPIC_ERROR } from 'Constants/redux';
import service from 'Api/service';
import { addStaffMemberNames } from 'Actions';

const AddStaffMemberNamesEpic = (action$) =>
  action$.pipe(
    ofType(ADD_STAFF_MEMBER_NAMES_REQUEST),
    switchMap(({ link }) =>
      from(service.get(`${import.meta.env.VITE_API_DOMAIN}${link}`)).pipe(
        map((response) => addStaffMemberNames(response)),
        catchError((error) => {
          console.error('AddStaffMemberNamesEpic error', error);
          return of({ type: EPIC_ERROR });
        })
      )
    )
  );

export default AddStaffMemberNamesEpic;
